import { api, headers } from "./api";

const RESOURCE = 'pembayaran';

export const getPembayaran = (tahun) => api.get(RESOURCE+'/'+tahun+'/wajib', headers);

export const getPembayaranRincian = (tahun) => api.get(RESOURCE+'/'+tahun+'/rincian', headers);

export const getPembayaranRiwayat = (tahun) => api.get(RESOURCE+'/'+tahun, headers);